export const MuiListItem = {
  styleOverrides: {
    root: {
      fontSize: '15px',
      fontWeight: 700,
      color: '#B1B8DA',
      '&$selected': { fontWeight: 500 },
    },
  },
};
